import { render, staticRenderFns } from "./DateTableView.vue?vue&type=template&id=57bd1d9d&scoped=true&"
import script from "./DateTableView.vue?vue&type=script&lang=js&"
export * from "./DateTableView.vue?vue&type=script&lang=js&"
import style0 from "./DateTableView.vue?vue&type=style&index=0&id=57bd1d9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd1d9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
